




























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { PropType } from 'vue';
import { UseService } from '@/services/service';
import GiftReactionService from '@/services/gift-reaction.service';
import { GiftReactionEntity } from '@/entities/gift-reaction.entity';

@Component<GiftReactionItem>({})
export default class GiftReactionItem extends Vue {
  @Prop({ type: Object as PropType<GiftReactionEntity> })
  reaction: GiftReactionEntity;

  show = false;

  @UseService(GiftReactionService)
  service: GiftReactionService;

  reactionDetails: GiftReactionEntity[] = [];

  @Watch('show')
  async handleChange(val) {
    if (val) {
      this.reactionDetails = await this.service.getMany(
        this.reaction.postId,
        this.reaction.emoticonId,
      );
    }
  }
}
